/**
 * @author Mau de Pallares
 * @company Erillam Healthcare
 * @version 2.0
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";
import ServicePath from "@/core/ServicePath";
export default class OptometryHistoryService extends MainService {
  static listAllPagination(params) {
    return this.postSEC(
      ServiceConstant.OPTOMETRY_LISTALLHISTORY_PAGINATION,
      params
    );
  }
  static get(params) {
    return this.postSEC(ServiceConstant.OPTOMETRY_GET_HISTORIAL, params);
  }
  static update(params) {
    return this.postSEC(ServiceConstant.OPTOMETRY_UPDATE, params);
  }

  static pdf(params) {
    return this.postPDFSEC(ServicePath.OPTOMETRY_PDF, params);
  }
  static excel(params) {
    return this.postPDFSEC(ServiceConstant.OPTOMETRY_EXCEL, params);
  }
  static productivity(params) {
    return this.postPDFSEC(ServicePath.OPTOMETRY_EXCELPRODUCTIVITY, params);
  }
}
